import * as React from 'react';

interface IThemeProps {
  name: 'default' | 'claims';
  children: React.ReactNode;
}

export const Theme = ({ name, children }: IThemeProps) => <div className={`theme theme--${name}`}>{children}</div>;
